import { useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import isEmpty from 'lodash/fp/isEmpty';
import LightBox from 'componets/light-box';
import styles from './driver-account-list.module.sass';
import { DriverAccountListItem } from './driver-account-list-item';
import { useEnterpriseDriverDelete } from '../../use-enterprise-driver-delete';
import analytics from 'service/analytics';

export const DriverAccountList = ({ accounts, refetchEnterpriseDrivers, onPageSelected, isDeleteAllowed }) => {
  const location = useLocation();
  const [selectedDeleteDriverAccountId, setSelectedDeleteDriverAccountId] = useState(null);
  const { deleteEnterpriseDriverMutateAsync, deleteEnterpriseDriverStatus } = useEnterpriseDriverDelete();
  const urlSearchParams = new URLSearchParams(location.search);
  const page = urlSearchParams.get('page');
  const searchQuery = urlSearchParams.get('search');

  const selectedDriverAccount = accounts.find(({ id }) => id === selectedDeleteDriverAccountId);

  const reset = useCallback(() => {
    setSelectedDeleteDriverAccountId(null);
  }, []);

  const handleAccountDelete = useCallback(async () => {
    analytics.driverPageDriverAccountConfirmDialogConfirmDeleteClick();
    try {
      await deleteEnterpriseDriverMutateAsync({ id: selectedDeleteDriverAccountId });
      refetchEnterpriseDrivers();
      reset();

      // Navigate back while the last item is deleted
      if (accounts.length === 1 && page > 1) {
        onPageSelected(page - 1);
      }
    } catch (error) {
      console.log(error);
    }
  }, [
    deleteEnterpriseDriverMutateAsync,
    selectedDeleteDriverAccountId,
    reset,
    refetchEnterpriseDrivers,
    accounts,
    page,
    onPageSelected,
  ]);

  if (isEmpty(accounts) && !!searchQuery) {
    return <div className={styles['empty-state']}>找不到與搜尋條件相符的帳號，請重新嘗試。</div>;
  }

  return (
    <>
      <ul className={styles['driver-account-list']}>
        {accounts.map(({ mobile, id }) => (
          <DriverAccountListItem
            key={id}
            mobile={mobile}
            isDeleteAllowed={isDeleteAllowed}
            onModifyButtonClick={() => {
              analytics.driverPageDriverAccountDeleteToggleClick();
              setSelectedDeleteDriverAccountId(id);
              analytics.driverPageDriverAccountConfirmDialogPageView();
            }}
          />
        ))}
      </ul>
      <LightBox
        approveText="確認移除"
        title={`確認移除駕駛帳號 ${selectedDriverAccount?.mobile ?? ''}？`}
        content="移除帳號後駕駛將無法使用條碼付，但不會影響到您的歷史消費紀錄。"
        show={selectedDeleteDriverAccountId !== null}
        loading={deleteEnterpriseDriverStatus === 'loading'}
        onCancel={() => {
          analytics.driverPageDriverAccountConfirmDialogCancelClick();
          setSelectedDeleteDriverAccountId(null);
        }}
        onApprove={handleAccountDelete}
      />
    </>
  );
};
